const NICKEL_ACTION_TYPES = {
  LOAD_NICKEL: 'nickel/LOAD_NICKEL',
};

export default NICKEL_ACTION_TYPES;
